import { IRequestOptions, TResponseResult } from 'models/api.model'
import { IAppConfigResponseRaw } from 'models/config.model'

import { ApiService } from 'services/api.service'

import { RequestMethod } from 'root-constants'

export class ConfigApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getAppConfig(
    appName: string,
    platform?: string,
  ): Promise<TResponseResult<IAppConfigResponseRaw>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: platform ? { platform } : undefined,
    }

    return this.api.makeRequest<IAppConfigResponseRaw>(
      `v1/flow/${appName}/config`,
      options,
    )
  }
}
